module.exports = __webpack_public_path__ + "img/lerner-makerlab-logo2.d7f75cee.svg";